"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStyled = exports.Text = exports.InputContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../../styles/palette");

var _widths = require("../../../../styles/widths");

var _index = _interopRequireDefault(require("../../Icon/index"));

var _templateObject, _templateObject2, _templateObject3;

var InputContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  & input[type=checkbox] {\n    display: none;\n  }\n  & input[type=checkbox]:hover + div {\n    filter: brightness(90%);\n  }\n  & > span {\n    padding: 0;\n    font-size: ", ";\n    line-height: 1.67;\n    text-align: left;\n    display: inline-block;\n    width: 100%;\n    & a {\n      color: ", ";\n      &:link {\n        color: ", ";\n      }\n    }\n  }\n  & label {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 0;\n    font-size: 12px;\n    line-height: 1.67;\n    text-align: left;\n    color: ", ";\n    & > div {\n      display: flex;\n    }\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])), _widths.widths.base, _widths.widths.base, function (props) {
  return props.fontSize ? props.fontSize : "".concat(14, "px");
}, function (props) {
  return props.color !== _palette.palette.bobBlack ? props.color : _palette.palette.link;
}, function (props) {
  return props.color !== _palette.palette.bobBlack ? props.color : _palette.palette.link;
}, function (props) {
  return props.error ? _palette.palette.error : props.color ? props.color : _palette.palette.bobBlack;
});

exports.InputContainer = InputContainer;

var Text = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 14px;\n  width: 100%;\n  & > div {\n    float: left;\n    margin: 0 ", "px;\n  }\n"])), _widths.widths.base / 2);

exports.Text = Text;
var IconStyled = (0, _styledComponents["default"])(_index["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", "px;\n  animation: ", ";\n  @keyframes bounce {\n    0% {\n      transform: scale(1.2, 1.2);\n    }\n    100% {\n      transform: scale(1, 1);\n    }\n  }\n"])), _widths.widths.base, function (props) {
  return props.error ? 'bounce 0.5s alternate infinite' : 'none';
});
exports.IconStyled = IconStyled;